import { Avatar, Badge, Box, IconButton, Tooltip } from '@mui/material'
import React, { useState } from 'react'
import { Mail, Notifications } from '@mui/icons-material'
import { useValue } from '../../context/ContextProvider';
import UserMenu from './UserMenu';
import useCheckToken from '../../hooks/useCheckToken';


const UserIcons = () => {

  useCheckToken();    //Para verificar que el Token del usuario no haya expirado

  const { state: { currentUser } } = useValue();
  const [ anchorUserMenu, setAnchorUserMenu] = useState(null);

  return (
    <Box >
      {/*<IconButton size='large' color='inherit'>
        <Badge color='error' badgeContent={5}>
          <Mail />
        </Badge>
      </IconButton>
      <IconButton size='large' color='inherit'>
        <Badge color='error' badgeContent={20}>
          <Notifications />
        </Badge>
  </IconButton>*/}
      <Tooltip title='Configuración de usuario' >
        <IconButton 
          onClick={(e) => {
            setAnchorUserMenu(e.currentTarget);
          }}
        >
          <Avatar src={currentUser?.photoURL} alt={currentUser?.name}>
            {currentUser?.name.charAt(0).toUpperCase()}
          </Avatar>
        </IconButton>
      </Tooltip>
      <UserMenu 
        anchorUserMenu={anchorUserMenu}
        setAnchorUserMenu={setAnchorUserMenu}
      />
    </Box>

  )
}

export default UserIcons